import { render, staticRenderFns } from "./ProfilePicEditor.vue?vue&type=template&id=156118ea&"
import script from "./ProfilePicEditor.vue?vue&type=script&lang=js&"
export * from "./ProfilePicEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports